import { BlogSection } from "@/types/blog";

export const intro: BlogSection = {
  id: "intro",
  title: "Einleitung",
  content: `
    <p>Gute Führungskräfte im Jahr 2026 zeichnen sich weniger durch Methoden oder Tools aus, sondern durch innere Stabilität, emotionale Reife und die Fähigkeit, sichere Beziehungen zu gestalten. Teams arbeiten dann am besten, wenn Vertrauen, Klarheit und psychologische Sicherheit vorhanden sind. Führung ist deshalb vor allem eine Frage der Haltung, nicht der Technik.</p>

    <p>Führung verändert sich.<br/>
    Nicht weil neue Konzepte auftauchen.<br/>
    Sondern weil Menschen sensibler geworden sind für das, was ihnen guttut und was nicht.</p>

    <p>Mitarbeitende folgen heute weniger Positionen und mehr Persönlichkeiten. Sie orientieren sich an Präsenz, Verlässlichkeit und innerer Ruhe. Wer führt, wirkt nicht über Lautstärke oder Kontrolle, sondern über Klarheit im Verhalten.</p>

    <p>Die entscheidende Frage lautet daher nicht: <em>Welche Methode nutze ich?</em><br/>
    Sondern: <em>Wie begegne ich anderen Menschen?</em></p>

    <p><strong>Führung beginnt innen.</strong></p>
  `
};
